/**
 * Politique d'impersonation — décision PURE (testable sans rendu).
 *
 * P0 frontière plateforme, sous-lot D (2026-07-23). FAIL-CLOSED : absence de
 * règle = absence de droit. Aucune valeur sentinelle (null, undefined) ne
 * signifie « toutes les cibles ». Le droit « toutes cibles » ne dérive QUE de
 * l'autorité plateforme canonique (`isPlatformSuper`, même signal que la garde
 * du Master Shell), et exclut l'impersonation d'un autre administrateur
 * plateforme.
 *
 * Les rôles IT tenant (IT / Administrateur / it_admin) n'ont AUCUNE entrée dans
 * les règles → aucun droit d'impersonation.
 */
import { PLATFORM_ADMIN_ROLES } from '../constants/roleGroups';

/**
 * @param {object} p
 * @param {string|null|undefined} p.userRole   rôle du VRAI utilisateur
 * @param {string|null|undefined} p.targetRole rôle de la cible
 * @param {boolean} p.isPlatformSuper          autorité plateforme canonique prouvée
 * @param {Record<string, string[]>} p.rules   IMPERSONATION_RULES (tableaux uniquement)
 * @returns {boolean}
 */
export function canImpersonateWith({ userRole, targetRole, isPlatformSuper, rules } = {}) {
  if (!userRole || !targetRole) return false; // cible/rôle inconnu → refus

  // Super canonique : toutes cibles SAUF un autre administrateur plateforme.
  if (isPlatformSuper === true) return !PLATFORM_ADMIN_ROLES.includes(targetRole);

  // Sinon : SEUL un tableau explicite accorde un droit. null/undefined → refus.
  const allowed = rules ? rules[userRole] : undefined;
  return Array.isArray(allowed) && allowed.includes(targetRole);
}
